import { auth } from './FirebaseInit'

export async function GET<T>(url: string): Promise<T> {
  const response = await fetch(url)
  if (!response.ok) {
    throw new Error(response.statusText)
  }
  const json = await response.json()
  return json
}

export async function GETWithAuth<T>(url: string): Promise<T> {
  const token = await auth.currentUser?.getIdToken()
  if (!token) {
    throw new Error('Token does not exist!')
  }

  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  if (!response.ok) {
    throw new Error(response.statusText)
  }
  const json = await response.json()
  return json
}

export async function POST<T, R>(url: string, data: T): Promise<R> {
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  if (!response.ok) {
    throw new Error(response.statusText)
  }
  return await response.json()
}

export async function POSTWithAuth<T, R>(url: string, data: T): Promise<R> {
  const token = await auth.currentUser?.getIdToken()
  if (!token) {
    throw new Error('Token does not exist!')
  }

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  if (!response.ok) {
    throw new Error(response.statusText)
  }
  return await response.json()
}

export async function POSTWithAuthNoResponse<T>(url: string, data: T): Promise<void> {
  const token = await auth.currentUser?.getIdToken()
  if (!token) {
    throw new Error('Token does not exist!')
  }

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  if (!response.ok) {
    throw new Error(response.statusText)
  }
  return
}

export async function PUTWithAuthNoResponse<T>(url: string, data: T): Promise<void> {
  const token = await auth.currentUser?.getIdToken()
  if (!token) {
    throw new Error('Token does not exist!')
  }

  const response = await fetch(url, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  if (!response.ok) {
    throw new Error(response.statusText)
  }
  return
}

export async function ExtractResumableURL(url: string): Promise<string | null> {
  const response = await fetch(url, {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors',
    headers: {
      'x-goog-resumable': 'start',
    },
  })
  return response.headers.get('location')
}

export async function ExtractResumableURLJpeg(url: string): Promise<string | null> {
  const response = await fetch(url, {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors',
    headers: {
      'x-goog-resumable': 'start',
      'Content-Type': 'image/jpeg',
    },
  })
  return response.headers.get('location')
}
